module.exports = __webpack_public_path__ + "img/1571603479.3a673da6.jpg";